import { nsApi } from 'boot/axios'
import setCssVar from 'quasar/src/utils/set-css-var.js';

export default {
  namespaced: true,

  state: {
    theme: null,
  },

  actions: {
    async init({ commit, state, rootState }, force = false) {
      if (!state.theme || force) {
        const { piva } = rootState.tenant
        const { data } = await nsApi.post('theme', { piva })
        commit('update', data)

        // configurazione colori
        if (data === 'Audiosoft')
          setCssVar('primary', '#007177')
        else
          setCssVar('primary', '#007EC2')
      }
    },
  },

  mutations: {
    update(state, theme) { state.theme = theme },
  },
}
